module.exports = __webpack_public_path__ + "static/media/ic_ac_close.51f343d5.png";